/**
 * SOLOMON — Wholesale Workspace
 * Consolidated wholesaling cockpit, rendered as a panel beside Research.
 * Left sub-nav switches the main area between Overview (landing), the three
 * reused tools (Call Queue / Find Leads / Leads), and three thin views
 * (Appointments / Inbound / Ad Performance). See spec 2026-06-18.
 */
import { useState, useEffect } from 'react';
import WorkspaceOverlay from '../shared/WorkspaceOverlay';
import './wholesale.css';
// leads.css styles the reused Call Queue / Find Leads / Leads panels (chips,
// filter strip, tables). It used to load globally via ChatInterface's LeadsImport
// import; now that those moved here, load it from the workspace so the panels
// keep their styling.
import '../Leads/leads.css';
import WholesaleOverview from './WholesaleOverview';
import AppointmentsView from './AppointmentsView';
import InboundView from './InboundView';
import AdPerformanceView from './AdPerformanceView';
import SignalQualityView from './SignalQualityView';
import CallQueuePanel from '../CallQueuePanel';
import LeadSearchPanel from '../LeadSearchPanel';
import LeadsView from '../Leads/LeadsView';
import LeadsImport from '../Leads/LeadsImport';

const SECTIONS = [
  { id: 'overview',     label: 'Overview' },
  { id: 'call-queue',   label: 'Call Queue' },
  { id: 'find-leads',   label: 'Find Leads' },
  { id: 'import',       label: 'Import Leads' },
  { id: 'leads',        label: 'Leads' },
  { id: 'appointments', label: 'Appointments' },
  { id: 'inbound',      label: 'Inbound' },
  { id: 'ads',          label: 'Ad Performance' },
  { id: 'signals',      label: 'Signal Quality' },
];

export default function WholesaleWorkspace({
  isOpen,
  initialSection = 'overview',
  initialLeadId = null,
  onConsumeInitialLeadId,
  onClose,
}) {
  const [section, setSection] = useState(initialLeadId ? 'leads' : initialSection);

  // Deep-link from chat ("open lead X") opens the panel + jumps to Leads.
  useEffect(() => {
    if (initialLeadId) setSection('leads');
  }, [initialLeadId]);

  return (
    <WorkspaceOverlay
      open={isOpen}
      title="Wholesale"
      onClose={onClose}
      ariaLabel="Wholesale workspace"
      className="ws-panel"
    >
      <div className="ws-body">
        <nav className="ws-nav">
          {SECTIONS.map((s) => (
            <button key={s.id} className={section === s.id ? 'active' : ''} onClick={() => setSection(s.id)}>
              {s.label}
            </button>
          ))}
        </nav>
        <div className="ws-content">
          {section === 'overview'     && <WholesaleOverview onNavigate={setSection} />}
          {section === 'call-queue'   && <CallQueuePanel />}
          {section === 'find-leads'   && <LeadSearchPanel />}
          {section === 'import'       && <LeadsImport />}
          {section === 'leads'        && <LeadsView initialLeadId={initialLeadId} onConsumeInitialLeadId={onConsumeInitialLeadId} />}
          {section === 'appointments' && <AppointmentsView />}
          {section === 'inbound'      && <InboundView />}
          {section === 'ads'          && <AdPerformanceView />}
          {section === 'signals'      && <SignalQualityView />}
        </div>
      </div>
    </WorkspaceOverlay>
  );
}
